
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exhibition/why",
      function () {
        return require("private-next-pages/exhibition/why/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exhibition/why"])
      });
    }
  